var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4269_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7378 26.258L17.349 29.081C20.0666 31.4429 23.1968 31.0697 24.6588 28.2117L25.6685 26.2405L15.7334 26.258H15.7378Z",
    fill: "#CD566C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5123 9.75512C15.0653 9.75512 12.2738 12.5466 12.2738 15.9937V19.6639C12.2738 20.9416 11.6374 22.1353 10.5713 22.846L10.5693 22.8473C10.1967 23.0937 9.97332 23.5105 9.97332 23.9576C9.97332 24.6958 10.5741 25.2966 11.3123 25.2966H21.5767C21.9404 25.2966 22.2353 25.5914 22.2353 25.9551C22.2353 26.3188 21.9404 26.6137 21.5767 26.6137H11.3123C9.8467 26.6137 8.65625 25.4232 8.65625 23.9576C8.65625 23.0704 9.09972 22.2407 9.84161 21.7495C10.5399 21.2836 10.9567 20.5019 10.9567 19.6639V15.9937C10.9567 11.8192 14.3379 8.43805 18.5123 8.43805C22.6868 8.43805 26.068 11.8192 26.068 15.9937V19.6639C26.068 20.5001 26.4877 21.2829 27.1837 21.7499C27.9252 22.2412 28.3684 23.0707 28.3684 23.9576C28.3684 25.4232 27.178 26.6137 25.7123 26.6137H24.6455C24.2818 26.6137 23.987 26.3188 23.987 25.9551C23.987 25.5914 24.2818 25.2966 24.6455 25.2966H25.7123C26.4506 25.2966 27.0514 24.6958 27.0514 23.9576C27.0514 23.5105 26.828 23.0937 26.4554 22.8473L26.4521 22.8451C25.3929 22.1355 24.7509 20.9432 24.7509 19.6639V15.9937C24.7509 12.5466 21.9594 9.75512 18.5123 9.75512Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.512 6.68194C18.0328 6.68194 17.6384 7.07637 17.6384 7.5556V9.25901C17.6384 9.62271 17.3435 9.91755 16.9798 9.91755C16.6161 9.91755 16.3213 9.62271 16.3213 9.25901V7.5556C16.3213 6.34897 17.3054 5.36487 18.512 5.36487C19.1082 5.36487 19.6577 5.60111 20.0577 6.00991C20.4665 6.40992 20.7028 6.95946 20.7028 7.5556V9.25901C20.7028 9.62271 20.4079 9.91755 20.0442 9.91755C19.6805 9.91755 19.3857 9.62271 19.3857 9.25901V7.5556C19.3857 7.31238 19.2911 7.10104 19.1337 6.94847C19.1288 6.9437 19.1239 6.93885 19.1191 6.93392C18.9666 6.77652 18.7552 6.68194 18.512 6.68194Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4476 25.2966C15.8113 25.2966 16.1061 25.5914 16.1061 25.9551C16.1061 27.2854 17.1848 28.361 18.512 28.361C19.8385 28.361 20.9178 27.2817 20.9178 25.9551C20.9178 25.5914 21.2127 25.2966 21.5764 25.2966C21.9401 25.2966 22.2349 25.5914 22.2349 25.9551C22.2349 28.009 20.5659 29.678 18.512 29.678C16.4587 29.678 14.7891 28.0141 14.7891 25.9551C14.7891 25.5914 15.0839 25.2966 15.4476 25.2966Z",
    fill: "#060606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4269_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.512207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.6df2ce043be7dab15bc66344e0e2e84b.svg";
export { ForwardRef as ReactComponent };